// import { IS_SP } from '../const/config';

export class FaqAccordion {
  constructor() {
    this.DOM = {};
    this.DOM.faqItems = document.querySelectorAll('[data-faq]');

    if (!this.DOM.faqItems) return;

    this.init();
  }

  init() {

    // 質問ごとの処理（複数のタブ設置に対応）
    this.DOM.faqItems.forEach( (item) => {
      const question = item.querySelector('[data-faq-q]');
      const answer = item.querySelector('[data-faq-a]');

      question.addEventListener('click', () => {

        // 現在開いているかチェック
        const isOpen = item.classList.contains('is-opened');

        if (isOpen) {
          // 【閉じる処理】高さを0にする
          answer.style.height = '0px';
          item.classList.remove('is-opened');
        } else {
          // 【開く処理】中身の本当の高さ（scrollHeight）を取得して適用
          const contentHeight = answer.scrollHeight;
          answer.style.height = `${contentHeight}px`;
          item.classList.add('is-opened');
        }
      });

    });
  }
}
